import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esTmsOcd } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/ocd`;

export const Route = createFileRoute("/es/services/ocd")({
  head: () => ({
    meta: [
      { title: "TMS para el TOC | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "TMS 3D SmartFocus® de Nexstim para el trastorno obsesivo-compulsivo en Coral Springs, FL. Estimulación magnética dirigida con imagen cuando los medicamentos.",
      },
      { property: "og:title", content: "TMS para el TOC | Neuro Wellness TMS" },
      {
        property: "og:description",
        content:
          "TMS 3D SmartFocus® de Nexstim para el TOC en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "TMS para el TOC | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "TMS 3D SmartFocus® de Nexstim para el TOC en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/ocd"),
    ],
  }),
  component: () => <EsServicePage cfg={esTmsOcd} />,
});
